// @file Show feedback nudge if user came from Import page.
// Only show once per wall.
import { trackEventOnlyOnce } from '@@/bits/command_bar'
import { requestIdleCallback } from '@@/bits/request_idle_callback'
import { tryCatch } from '@@/bits/try_catch'

const showFeedbackNudgeAfterCompletedWallImport = async (): Promise<void> => {
  // Only show after 1 second when idle
  await new Promise<void>((r) => requestIdleCallback(r))
  await new Promise((r) => setTimeout(r, 1000))

  const [referrerUrl, error] = tryCatch(() => new URL(document.referrer))
  if (error) {
    // Invalid referrer URL, just ignore it
    return
  }

  if (referrerUrl.hostname === window.location.hostname && referrerUrl.pathname.endsWith('/import')) {
    // Check document source to skip feedback for PDF imports
    const { useTldrawEditor } = await import('@@/vuecomposables/useTldrawEditor')
    const { editor } = useTldrawEditor()

    if (editor == null) {
      // Editor not yet mounted, be conservative and don't show nudge
      return
    }

    const documentMeta = editor.getDocumentSettings().meta

    // Skip feedback nudge for PDF imports
    // This must match `WallImporting::Importer::IMPORT_SOURCE_PDF` in Rails backend
    if (documentMeta?.source === 'pdf') {
      return
    }

    const { useSurfaceStore } = await import('@@/pinia/surface')
    const surfaceStore = useSurfaceStore()

    trackEventOnlyOnce('wallImportCompletedFeedbackNudge', { localStorageKeySuffix: surfaceStore.wallId })
  }
}

export { showFeedbackNudgeAfterCompletedWallImport }
